import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class RefTypeFichier extends IdCodeLibelle {}
